import { WorkspaceLimitsDc } from "@evergis/api";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getUsername } from "../../../../../../ducks/user";
import { TableInfo } from "../../../../../../interfaces/resourceInfo";

import { FILTERED_OPTIONS } from "../../../constants";

export const useCopyLayerOptions = (
  isFiltered: boolean,
  table: TableInfo,
  limits: WorkspaceLimitsDc | undefined,
): [string, (value: string) => void] => {
  const [options, setCopyTablesOption] = useState<string>();
  const currentUser: string = useSelector(getUsername);
  const isTablesLimit: boolean = limits && limits.currentTableCount >= limits.maxTablesCount;

  useEffect(() => {
    if (!table || !currentUser) {
      return;
    }

    const value =
      currentUser !== table.owner && !isTablesLimit
        ? isFiltered
          ? FILTERED_OPTIONS.FILTERED_ONLY
          : FILTERED_OPTIONS.FULL_DATA
        : FILTERED_OPTIONS.NO_TABLES;

    setCopyTablesOption(value);
  }, [table, currentUser, limits]);

  return [options, setCopyTablesOption];
};
